import { CaretLeft } from '@ui/components/icons';
import { TradeableTokenMenuSelect } from '@ui/features/MassiveToken/components/TradeableTokenMenuSelect';
import { Button } from '@ui/lib/park/ui/button';
import { Icon } from '@ui/lib/park/ui/icon';
import { Flex, FlexProps } from 'styled-system/jsx';

export const Head = (p: FlexProps) => {
  return (
    <Flex
      bg="black.background"
      alignItems="center"
      gap="24px"
      minH={{
        base: '44px',
        desktop: '64px',
      }}
      p={{
        base: '0px 16px',
        desktop: '16px',
      }}
      {...p}
    >
      <TradeableTokenMenuSelect />
    </Flex>
  );
};
